import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('cocoa_river', {
  cherry: 'cocoa_bean',
  lemon: 'caramel_cube',
  orange: 'fudge_slab',
  bell: 'truffle',
  star: 'choc_falls',
  seven: 'cocoa_barge',
  gem: 'caramel_gem',
  scatter: 'golden_egg',
  money: 'choc_fountain',
});

/** Cocoa River — GENERATED by scaffoldSlot from
 *  content/slots/cocoa_river.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const COCOA_RIVER_THEME: Theme = {
  id: 'cocoa_river',
  name: 'Cocoa River',
  palette: {
    accent: 0xe0a52e,
    secondary: 0x8a4a26,
    warm: 0xffe0b0,
    frameFill: 0x2a1409,
    bgGradientTop: 0x3a1d0e,
    bgGradientBottom: 0x140a05,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Cocoa Bean', glyph: '🫘', tint: 0x6b3a1e, weight: 5, textureAlias: 'cocoa_river:cherry',
        winVideoAlias: 'cocoa_river:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Caramel Cube', glyph: '🟫', tint: 0xe0a52e, weight: 5, textureAlias: 'cocoa_river:lemon',
        winVideoAlias: 'cocoa_river:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Fudge Slab', glyph: '🍫', tint: 0x8a4a26, weight: 4, textureAlias: 'cocoa_river:orange',
        winVideoAlias: 'cocoa_river:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Chocolate Truffle', glyph: '🍬', tint: 0x6b3a1e, weight: 3, textureAlias: 'cocoa_river:bell',
        winVideoAlias: 'cocoa_river:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Chocolate Falls', glyph: '⭐', tint: 0xe0a52e, weight: 2, textureAlias: 'cocoa_river:star',
        winVideoAlias: 'cocoa_river:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Cocoa Barge', glyph: '⛵', tint: 0x8a4a26, weight: 2, textureAlias: 'cocoa_river:seven',
        winVideoAlias: 'cocoa_river:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Caramel Gem', glyph: '💎', tint: 0xe0a52e, weight: 2.5, textureAlias: 'cocoa_river:gem',
        winVideoAlias: 'cocoa_river:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Golden Egg', glyph: '🥚', tint: 0xe0a52e, weight: 0.5, textureAlias: 'cocoa_river:scatter',
        winVideoAlias: 'cocoa_river:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Chocolate Fountain', glyph: '🪙', tint: 0xe0a52e, weight: 1, textureAlias: 'cocoa_river:money',
        winVideoAlias: 'cocoa_river:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a1409, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xe0a52e, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffe0b0, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x8a4a26, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xe0a52e, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffe0b0, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffe0b0, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a1409, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x8a4a26, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xe0a52e, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffe0b0, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffe0b0, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'cocoa_river:bg', path: 'environment/cocoa_river.png' },
      columnBackground: { alias: 'cocoa_river:column_bg', path: 'reel/cocoa_river_column_bg.png' },
      border: { alias: 'cocoa_river:border', path: 'brand/border_candy.png' },
    },
  },
};
